import AddAdvertisement from './AddAdvertisement'

export default AddAdvertisement
